import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withTabletBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';
import withReducer from '@Hooks/withReducer';

import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';

import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { breadcrumbsReducerKey } from './BreadcrumbsConstants';
import { retrieveBreadcrumbs as retrieveBreadcrumbsAction, setBreadcrumbsOrder } from './BreadcrumbsActions';
import { breadcrumbsIdsWithOrder, breadcrumbsOrder } from './BreadcrumbsSelectors';
import breadcrumbsReducer from './BreadcrumbsReducer';
import Breadcrumbs from './Breadcrumbs';

function mapStateToProps(state) {
  return {
    databaseId: databaseIdSelector(state),
    breadcrumbsIds: breadcrumbsIdsWithOrder(state),
    breadcrumbsOrder: breadcrumbsOrder(state),
  };
}

const mapDispatchToProps = {
  retrieveBreadcrumbs: retrieveBreadcrumbsAction,
  setBreadcrumbsOrder,
};

function BreadcrumbsContainer(props) {
  const { retrieveBreadcrumbs, databaseId, resultName } = props;

  useEffect(() => {
    retrieveBreadcrumbs(databaseId);
  }, [retrieveBreadcrumbs, databaseId]);

  useEffect(() => {
    if (resultName !== undefined) {
      retrieveBreadcrumbs(databaseId);
    }
  }, [retrieveBreadcrumbs, databaseId, resultName]);

  return <Breadcrumbs {...props} />;
}
BreadcrumbsContainer.propTypes = {
  retrieveBreadcrumbs: PropTypes.func.isRequired,
  databaseId: PropTypes.string.isRequired,
  resultName: PropTypes.string,
};

const EnhancedBreadcrumbsContainer = withCombinedRouteParams(
  withReducer(
    breadcrumbsReducerKey,
    breadcrumbsReducer,
    true
  )(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withTabletBreakpoint({
        handler: (props, media) => {
          props.setBreadcrumbsOrder(media.matches ? 'tablet' : 'desktop');
        },
      })(BreadcrumbsContainer)
    )
  )
);

export default EnhancedBreadcrumbsContainer;
